var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { MaskedInput } from '../MaskedInput';

var EmailInput = function (_Component) {
  _inherits(EmailInput, _Component);

  function EmailInput() {
    _classCallCheck(this, EmailInput);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  EmailInput.prototype.render = function render() {
    return React.createElement(MaskedInput, _extends({
      inputMode: 'email'
    }, this.props));
  };

  return EmailInput;
}(Component);

EmailInput.defaultProps = {
  mask: MaskedInput.emailMask
};


var EmailInputDoc = void 0;
if (process.env.NODE_ENV !== 'production') {
  EmailInputDoc = require('./doc').default(EmailInput); // eslint-disable-line global-require
}

var EmailInputWrapper = EmailInputDoc || EmailInput;

export { EmailInputWrapper as EmailInput };


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/components/EmailInput/EmailInput.js
// module id = 1149
// module chunks = 0